import AppHeader from "../../layout/AppHeader";
import Sender from '../../xpost/views/register/sender/Sender.vue';
import SenderAdd from '../../xpost/views/register/sender/SenderAdd.vue';

const RecipientSenderRoutes = [
    {
        path: "/cadastro/remetente",
        name: "sender",
        components: {
            header: AppHeader,
            default: Sender
        }
    },
    {
        path: "/cadastro/remetente/adicionar",
        name: "sender.add",
        components: {
            header: AppHeader,
            default: SenderAdd
        }
    },
    {
        path: "/cadastro/remetente/adicionar/:id",
        name: "sender.edit",
        components: {
            header: AppHeader,
            default: SenderAdd
        }
    },
]

export default RecipientSenderRoutes;